import { render, staticRenderFns } from "./RealNameForm.vue?vue&type=template&id=45a85f5a&scoped=true"
import script from "./RealNameForm.vue?vue&type=script&lang=js"
export * from "./RealNameForm.vue?vue&type=script&lang=js"
import style0 from "./RealNameForm.vue?vue&type=style&index=0&id=45a85f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a85f5a",
  null
  
)

export default component.exports